import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { FocusFieldDirective } from '@games/core/focus';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import { MathUtils } from '../../utils';
import { MathOperationWritable } from '../math-operation';
import { InputWithCalculatorDirective } from '@games/core/focus/InputWithCalculator';
import { VirtualKeyboardDirective } from '@games/core/input/VirtualKeyboard';

@Component({
  selector: 'ms-math-sub',
  templateUrl: './math-sub.component.html',
  styleUrls: ['./math-sub.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FocusFieldDirective,
    VirtualKeyboardDirective,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MathSubComponent),
      multi: true,
    },
  ],
  hostDirectives: [DimensionsListenerDirective],
})
export class MathSubComponent extends MathOperationWritable {
  readonly valueControl = new FormControl<string>('');

  fontSize = 28;

  @Input()
  public get value(): string {
    return this._value;
  }

  public set value(value: string) {
    this._value = value;
    this.updateViewBox();
    // this.valueControl.setValue(value);
  }

  private _value: string = '';

  @Input()
  public get useTextInput(): boolean {
    return this._useTextInput;
  }

  public set useTextInput(value: boolean) {
    this._useTextInput = value;
    if (value) {
      this.value = this.valueControl.value;
      this.updateViewBox();
    }
  }

  private _useTextInput: boolean = false;

  constructor() {
    super();
    this.valueControl.valueChanges.subscribe((value) => {
      this.value = value;
      this.updateViewBox();
      this.emitChanges();
    });
  }

  writeValue(value: string): void {
    if (value) {
      this.value = value;
      this.valueControl.setValue(value.toString());
      this.updateViewBox();
    }
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.valueControl.disable();
    } else {
      this.valueControl.enable();
    }
  }

  private updateViewBox(): void {
    let valueWidth =
      [''].includes(this.value) && !this.useTextInput
        ? 0
        : Math.max(
            20,
            MathUtils.getTextWidth(this.value.toString(), {
              size: this.fontSize,
              family: this.fontFamily,
              weight: this.fontWeight,
            }) / 2,
          );

    if (this.useTextInput) {
      valueWidth += 10;
    }

    const height = this.fontSize * 2 + this.fontSize / 14;

    this._setViewBox(valueWidth, height);
  }

  emitChanges() {
    this.onChange(this.value.toString());
  }
}
